var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIconProjectManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2883_8361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 21.7273V18.2727L35.8397 17.0084C35.4217 14.7813 34.5482 12.7155 33.3161 10.9134L34.6565 7.78588L32.2135 5.34294L29.086 6.6833C27.2833 5.45118 25.2181 4.57776 22.9911 4.15976L21.7273 1H18.2727L17.0084 4.16033C14.7813 4.57833 12.7155 5.45176 10.9134 6.68388L7.78588 5.34351L5.34294 7.78645L6.6833 10.914C5.45118 12.7167 4.57776 14.7819 4.15976 17.0089L1 18.2727V21.7273L4.16033 22.9916C4.57833 25.2187 5.45176 27.2845 6.68388 29.0866L5.34351 32.2141L7.78645 34.6571L10.914 33.3167C12.7167 34.5488 14.7819 35.4222 17.0089 35.8402L18.2727 39H21.7273L22.9916 35.8397C25.2187 35.4217 27.2845 34.5482 29.0866 33.3161L32.2141 34.6565L34.6571 32.2135L33.3167 29.086C34.5488 27.2833 35.4222 25.2181 35.8402 22.9911L39 21.7273Z",
    stroke: "white",
    strokeWidth: 1.45,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 11,
    stroke: "white",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2883_8361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9767 14.503C22.5876 14.5083 22.2159 14.6645 21.9397 14.9385L14.9378 21.9404C14.658 22.2216 14.5014 22.6023 14.5023 22.9989L14.4983 24.9999C14.498 25.0659 14.5108 25.1313 14.536 25.1923C14.5611 25.2534 14.5981 25.3088 14.6447 25.3555C14.6914 25.4021 14.7468 25.4391 14.8079 25.4642C14.8689 25.4894 14.9343 25.5022 15.0003 25.5019L17.0013 25.4979C17.1977 25.4984 17.3922 25.4602 17.5738 25.3855C17.7555 25.3107 17.9206 25.201 18.0597 25.0624L25.0617 18.0605C25.3407 17.7779 25.4972 17.3967 25.4972 16.9995C25.4972 16.6023 25.3407 16.2211 25.0617 15.9385L24.0617 14.9385C23.9192 14.797 23.7498 14.6855 23.5634 14.6107C23.377 14.5358 23.1775 14.4992 22.9767 14.503ZM22.9917 15.499C23.1267 15.497 23.2567 15.551 23.3527 15.6465L24.3537 16.6475C24.4009 16.6933 24.4385 16.748 24.4642 16.8086C24.4899 16.8691 24.5031 16.9342 24.5031 17C24.5031 17.0658 24.4899 17.1309 24.4642 17.1914C24.4385 17.252 24.4009 17.3068 24.3537 17.3525L23.7062 17.999L22.0012 16.294L22.6477 15.6465C22.7387 15.5546 22.8624 15.5017 22.9917 15.499ZM21.2942 17.001L22.9992 18.706L17.7053 23.9999L16.0003 22.2949L21.2942 17.001ZM15.4983 23.2069L16.7923 24.5009H15.4983V23.2069Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2883_8361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2883_8361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(14.0002 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconProjectManagement);
export default __webpack_public_path__ + "static/media/Home-Icon-ProjectManagement.51180b160c6c26a45d30a1b09897bb80.svg";
export { ForwardRef as ReactComponent };